module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expand-transition', [(_vm.transactions.length > 1) ? _c('div', _vm._l((_vm.transactions), function(transaction) {
    return _c('div', {
      key: transaction['.key'],
      staticClass: "simultaneous-transaction",
      class: {
        'active': transaction.active, 'hoverable': !transaction.active, 'clickable': !transaction.active
      },
      on: {
        "click": function($event) {
          return _vm.goToAnother(transaction['.key'])
        }
      }
    }, [_vm._v("\n        " + _vm._s(transaction.description) + " "), _c('span', {
      staticClass: "subtle"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(transaction.created)))]), _vm._v(" "), _c('a', {
      staticClass: "transparent",
      attrs: {
        "href": _vm.getLink(transaction['.key']),
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(!transaction.active) ? _c('v-btn', {
      staticStyle: {
        "float": "right",
        "margin-right": "-7px",
        "margin-top": "-3px"
      },
      attrs: {
        "color": "grey darken-1",
        "icon": "",
        "text": "",
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-open-in-new")])], 1) : _vm._e()], 1)])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-784b258f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/SimultaneousTransactions.vue
// module id = 2613
// module chunks = 1